module.exports = __webpack_public_path__ + "static/img/core-illustration-ch.4e74360.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/core-illustration-ch.png
// module id = wr+2
// module chunks = 0